import {
  CREATE_PAGE_SETTING_SUCCESS, FETCH_PAGE_SETTING_FOR_PAGE_SUCCESS,
  FETCH_PAGE_SETTING_SUCCESS,
  GET_PAGE_SETTING_SUCCESS,
  SAVE_PAGE_SETTING_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  pageSettings:{},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_PAGE_SETTING_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_PAGE_SETTING_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_PAGE_SETTING_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_PAGE_SETTING_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }
    case FETCH_PAGE_SETTING_FOR_PAGE_SUCCESS: {
      return {
        ...state,
        pageSettings: action.data,
      }
    }
    default:
      return state;
  }
}
